import { makeAutoObservable } from 'mobx'

/**
 * @class WorkflowsStore
 * @description This class represents the store for workflows. It manages the state of workflows and is part of the root store.
 */
class WorkflowsStore {
	/**
	 * @property {Object} workflows - An object containing workflows indexed by their IDs.
	 */
	workflows = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of WorkflowsStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default WorkflowsStore
